import { Box } from '@material-ui/core';
import { ChatMessageAgentButtons as ChatMessageAgentButtonsType } from '@src/types';

type ChatMessageAgentButtonsProps = {
  buttons: ChatMessageAgentButtonsType['buttons'];
};

const ChatMessageAgentButtons: React.FC<ChatMessageAgentButtonsProps> = ({
  buttons,
}) => {
  if (!buttons.length) return null;
  return (
    <div className="ChatMessageAgentButtons">
      {buttons?.map(({ id, tittle, active = false }) => (
        <Box
          key={id}
          className={'ChatMessageAgentButton'.concat(active ? ' active ' : '')}
        >
          {tittle}
        </Box>
      ))}
    </div>
  );
};

export default ChatMessageAgentButtons;
